import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../services/archismall.service';

class ConservazioneCaricaDocumentoStep3Controller implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'store',
        'jwtHelper',
        '$uibModal',
        'ArchiSmallServices'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: any,
        private $http: ng.IHttpService,
        private configuration: any,
        private store: ng.a0.storage.IStoreService,
        private jwtHelper: any,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private ArchiSmallServices: ArchiSmallServices
    ) {
        $scope.pageHeader = 'Carica Documento';
        $scope.pageSubHeader = 'Riepilogo';

        let result = store.get('ConservazioneCaricaDocumento-Result');

        if (result === undefined) {
            $state.go('home.home-index');
        }

        $scope.result = result;

        $scope.next = () => {
            $state.go('home.conservazione');
        };
    }

}

export const ConservazioneCaricaDocumentoStep3Component: ng.IComponentOptions = {
    template: require('./conservazione-carica-documento-step3.html'),
    controller: ConservazioneCaricaDocumentoStep3Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-step3/conservazione-carica-documento-step3.ts